import { JSX, ReactNode } from 'react'

import LogoUpload from '@/components/forms/document-upload-step/common-tabs/LogoUpload'
import NationalCardID from '@/components/forms/document-upload-step/common-tabs/NationalCardID'
import TaxRegCert from '@/components/forms/document-upload-step/common-tabs/TaxRegCert'
import BusinessLicense from '@/components/forms/document-upload-step/individual-tabs/BusinessLicense'
import CompanyStatute from '@/components/forms/document-upload-step/legal-tabs/CompanyStatute'
import OfficialNewspaper from '@/components/forms/document-upload-step/legal-tabs/OfficialNewspaper'

import {
  TCorrectionMappedData,
  TDocumentFormikValuesType
} from '@/types/uploader'

interface IUploadTab {
  key: number
  title: string
}

interface ITabsContent {
  [key: string]: ReactNode
}

export const uploaderTabs = {
  BUSINESS_LOGO: 1,
  NATIONAL_ID_CARD: 2,
  NATIONAL_ID_CARD_BACK_SIDE: 2,
  BIRTH_CERTIFICATE: 2,
  BUSINESS_LICENSE: 3,
  OFFICIAL_NEWSPAPER: 3,
  TAX_REGISTRATION_CERTIFICATE: 4,
  COMPANY_ARTICLES_OF_ASSOCIATION: 5
}

const TAB_TITLES = {
  LOGO: 'تصویر لوگو',
  NATIONAL_ID: 'کارت ملی و شناسنامه',
  OFFICIAL_NEWSPAPER: 'روزنامه رسمی',
  TAX_CERTIFICATE: 'گواهی ثبت مالیاتی',
  COMPANY_STATUTE: 'اساسنامه شرکت',
  BUSINESS_LICENSE: 'جواز کسب یا اینماد'
} as const

export const legalUploadTabs: IUploadTab[] = [
  { key: 1, title: TAB_TITLES.LOGO },
  { key: 2, title: TAB_TITLES.NATIONAL_ID },
  { key: 3, title: TAB_TITLES.OFFICIAL_NEWSPAPER },
  { key: 4, title: TAB_TITLES.TAX_CERTIFICATE },
  { key: 5, title: TAB_TITLES.COMPANY_STATUTE }
]

export const individualUploadTabs: IUploadTab[] = [
  { key: 1, title: TAB_TITLES.LOGO },
  { key: 2, title: TAB_TITLES.NATIONAL_ID },
  { key: 3, title: TAB_TITLES.BUSINESS_LICENSE },
  { key: 4, title: TAB_TITLES.TAX_CERTIFICATE }
]

type TabContentMap = {
  [key: string]: JSX.Element
}

const individualComponents = [
  LogoUpload,
  NationalCardID,
  BusinessLicense,
  TaxRegCert
]

export const individualTabsContentFactory = (
  formik: TDocumentFormikValuesType,
  isIndividual: boolean,
  corrections: TCorrectionMappedData
): TabContentMap => {
  const tabContent: TabContentMap = {}

  for (let index = 0; index < individualComponents.length; index++) {
    const Component = individualComponents[index]
    tabContent[(index + 1).toString()] = (
      <Component
        key={index}
        formik={formik}
        isIndividual={isIndividual}
        corrections={corrections}
      />
    )
  }

  return tabContent
}

const legalComponents = [
  LogoUpload,
  NationalCardID,
  OfficialNewspaper,
  TaxRegCert,
  CompanyStatute
]

export const legalTabsContentFactory = (
  formik: TDocumentFormikValuesType,
  isIndividual: boolean,
  corrections: TCorrectionMappedData
): TabContentMap => {
  const tabContent: TabContentMap = {}

  for (let index = 0; index < legalComponents.length; index++) {
    const Component = legalComponents[index]
    tabContent[(index + 1).toString()] = (
      <Component
        key={index}
        formik={formik}
        isIndividual={isIndividual}
        corrections={corrections}
      />
    )
  }

  return tabContent
}

export type { IUploadTab, ITabsContent }
